import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Board from "../pages/board/page";
import PostDetail from "../pages/board/post/page";
import Manual from "../pages/manual/page";
import ManualArticle from "../pages/manual/article/page";
import PartnerDashboard from "../pages/partner/dashboard/page";
import PartnerList from "../pages/partner/list/page";
import PartnerProfile from "../pages/partner/profile/page";
import Login from "../pages/auth/login/page";
import Register from "../pages/auth/register/page";
import ProfileSetup from "../pages/auth/profile-setup/page";
import PartnerProfilePage from "../pages/partner/profile/page";
import PartnerRecruitPage from "../pages/partner/recruit/page";
import MyPage from "../pages/mypage/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/auth/login",
    element: <Login />,
  },
  {
    path: "/auth/register",
    element: <Register />,
  },
  {
    path: "/auth/profile-setup",
    element: <ProfileSetup />,
  },
  {
    path: "/mypage",
    element: <MyPage />,
  },
  {
    path: "/board",
    element: <Board />,
  },
  {
    path: "/board/post/:id",
    element: <PostDetail />,
  },
  {
    path: "/manual",
    element: <Manual />,
  },
  {
    path: "/manual/:id",
    element: <ManualArticle />,
  },
  {
    path: "/partners",
    element: <PartnerList />,
  },
  {
    path: "/partners/:id",
    element: <PartnerProfilePage />,
  },
  {
    path: "/partner/recruit",
    element: <PartnerRecruitPage />,
  },
  {
    path: "/partner/dashboard",
    element: <PartnerDashboard />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
